export const LOG_GROUP_ATTRIBUTE_NAME = 'sa-contact-log-group'
export const CONTACT_LOG = 'contact-log'
